import React from "react";
import LoginCard from "@presentation/components/loginCard/LoginCard";

/**
 * The login page.
 * @returns Functional component
 */
const LoginPage: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
      }}
    >
      <LoginCard />
    </div>
  );
};

export default LoginPage;
